"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICSMimeTypes = exports.XPSMimeTypes = exports.SketchMimeTypes = exports.IllustratorMimeTypes = exports.PhotoshopMimeTypes = exports.EPSMimeTypes = exports.SVGMimeTypes = exports.VcardMimeTypes = exports.CSVMimeTypes = exports.TtfMimeTypes = exports.TiffMimeTypes = exports.TextMimeTypes = exports.CadMimeTypes = exports.DwgMimeTypes = exports.DXFMimeTypes = exports.XmlMimeTypes = exports.PdfMimeTypes = exports.ArchiveMimeTypes = exports.OpenDocumentMimeTypes = exports.SpreadsheetMimeTypes = exports.PowerpointMimeTypes = exports.WordMimeTypes = exports.AudioMimeTypes = exports.VideoMimeTypes = exports.GifMimeTypes = exports.ImageMimeTypes = void 0;
exports.ImageMimeTypes = [
    "image/jpeg",
    "image/png",
    "image/bmp",
    "image/pjpeg",
    "image/vnd.microsoft.icon",
    "image/vnd.wap.wbmp",
    "image/webp",
    "image/heif",
    "image/heic",
];
exports.GifMimeTypes = ["image/gif"];
exports.VideoMimeTypes = [
    "video/webm",
    "video/mpeg",
    "video/mp4",
    "video/x-flv",
    "video/3gpp",
    "video/3gpp2",
    "video/ogg",
    "video/quicktime",
    "video/x-msvideo",
    "video/x-ms-wmv",
    "video/mp2t",
    "video/MP2P",
    "video/MP1S",
    "video/avi",
    "application/x-mpeg",
    "video/x-msvideo",
    "video/x-ms-wmv",
];
exports.AudioMimeTypes = [
    "audio/mp3",
    "audio/aac",
    "audio/midi",
    "audio/x-midi",
    "audio/mpeg",
    "audio/ogg",
    "audio/wav",
    "audio/webm",
    "audio/3gpp",
    "audio/3gpp2",
    "audio/basic",
    "audio/L24",
    "audio/mp4",
    "audio/vorbis",
    "audio/x-ms-wma",
    "audio/x-ms-wax",
    "audio/x-wav",
    "audio/vnd.rn",
    "audio/vnd.wave",
    "audio/x-m4a",
    "audio/m4a",
];
exports.WordMimeTypes = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
exports.PowerpointMimeTypes = [
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    "application/vnd.ms-powerpoint.addin.macroEnabled.12",
];
exports.SpreadsheetMimeTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
];
exports.OpenDocumentMimeTypes = [
    "application/vnd.oasis.opendocument.text",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.oasis.opendocument.graphics",
];
exports.ArchiveMimeTypes = [
    "application/vnd.rar",
    "application/x-rar",
    "application/x-rar-compressed",
    "application/octet-stream",
    "application/zip",
    "application/x-zip-compressed",
    "multipart/x-zip",
    "application/gzip",
    "application/tar",
    "application/tar+gzip",
    "application/x-gzip",
    "application/x-gtar",
    "application/x-tgz",
    "application/x-tar",
    "application/x-bzip",
    "application/x-bzip2",
    "application/x-7z-compressed",
];
exports.PdfMimeTypes = ["application/pdf"];
exports.XmlMimeTypes = ["application/xml", "text/xml"];
exports.DXFMimeTypes = ["image/vnd.dxf"];
exports.DwgMimeTypes = ["image/vnd.dwg"];
exports.CadMimeTypes = [
    "model/example",
    "model/iges",
    "model/mesh",
    "model/vrml",
    "model/x3d+binary",
    "model/x3d+vrml",
    "model/x3d+xml",
];
exports.TextMimeTypes = [
    "text/cmd",
    "text/css",
    "text/html",
    "text/javascript",
    "text/plain",
    "text/php",
    "text/markdown",
    "text/cache-manifest",
];
exports.TiffMimeTypes = ["image/tiff"];
exports.TtfMimeTypes = [
    "font/sfnt",
    "font/ttf",
    "application/font-sfnt",
    "application/x-font-ttf",
];
exports.CSVMimeTypes = ["text/csv"];
exports.VcardMimeTypes = ["text/vcard", "text/x-vcard"];
exports.SVGMimeTypes = ["image/svg+xml"];
exports.EPSMimeTypes = [
    "image/x-eps",
    "application/postscript", // eps / ps
];
exports.PhotoshopMimeTypes = [
    "image/vnd.adobe.photoshop",
    "application/x-photoshop",
    "application/photoshop",
    "application/psd",
    "image/psd",
];
exports.IllustratorMimeTypes = [
    "application/illustrator", // ai
];
exports.SketchMimeTypes = [
    "application/x-sqlite3", // sketch
];
exports.XPSMimeTypes = [
    "application/vnd.ms-xpsdocument",
    "application/oxps",
];
exports.ICSMimeTypes = ["text/calendar"];
